import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";

import { initKeycloak } from './keycloak'; // Importiere die Keycloak-Initialisierungsfunktion

initKeycloak().then(() => {
  const app = createApp(App);
  app.use(router);
  app.mount('#app');
}).catch((error) => {
  console.error("Keycloak initialization failed:", error);
});







